<template>
  <Transition name="fade-left">
    <aside v-if="showSideMenu" class="m-sidebar">
      <!-- <template v-if="isLogin"> -->
      <div class="m-sidebar__header">
        <div class="btn-close" @click="closeSideMenu">
          <img src="@/assets/images/x-close-black.svg" />
        </div>
      </div>
      <div class="m-sidebar__body">
        <ul v-if="!isLogin" class="sub-menu">
          <li v-for="(item, key) of startMenu" :key="key" class="menu-item" @click="closeSideMenu">
            <router-link :to="item.path" class="menu-link">
              {{ item.title }}
              <badge
                v-if="item.path === '/news' && isShowNewsIcon"
                class="danger ml-6"
                title="NEW!"
              />
            </router-link>
          </li>
        </ul>

        <Menu v-else display="vertical" />
      </div>
      <!-- </template> -->
    </aside>
  </Transition>
</template>

<script>
// import { computed } from 'vue';
// import { useStore } from 'vuex';
import { START_MENU as startMenu } from '@/constants/common';
import { mapGetters, mapActions } from 'vuex';

// const store = useStore();
// const isLogin = computed(() => store.state.auth.isLogin);
// const showSideMenu = computed(() => store.state.common.showSideMenu);

// const closeSideMenu = () => {
//   store.commit('common/SET_SHOW_SIDE_MENU', false);
// };

export default {
  data() {
    return {
      startMenu
    };
  },

  computed: {
    ...mapGetters({ isLogin: 'auth/isLogin' }),
    ...mapGetters({ showSideMenu: 'common/showSideMenu' }),
    ...mapGetters({ isShowNewsIcon: 'news/isShowNewsIcon' }),
  },
  methods: {
    closeSideMenu() {
      this.$store.commit('common/SET_SHOW_SIDE_MENU', false);
    },
  }
};

</script>

<style lang="scss" scoped>
.m-sidebar {
  width: 300px;
  max-width: 100%;
  height: 100vh;
  overflow: auto;
  background: #fff;
  position: fixed;
  top: 0;
  z-index: 99999;
  right: 0;
  box-shadow: -5px 0 20px 2px rgba(0, 0, 0, 0.2);

  &__header {
    padding: 14px 11px;
    position: relative;
    &::after {
      content: '';
      height: 1px;
      width: calc(100% - 22px);
      background-color: #f3f3f3;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
    }
  }

  &__body {
    padding: 11px;
  }
}

.sub-menu {
  padding-left: 0;
  list-style-type: none;
  display: flex;
  flex-direction: column;

  .menu {
    &-item {
      display: block;
      &:not(:last-child) {
        border-bottom: 1px solid #f3f3f3;
      }
    }

    &-link {
      display: block;
      height: 39px;
      padding: 10px;
      display: flex;
      align-items: center;
      color: #222222;
      font-family: 'Segoe UI', 'Semibold';

      &.router-link-active {
        background-color: #04a4de1a;
        color: #04a4de;
        padding-left: 3px;
      }
    }
  }
}

.ml-6 {
  margin-left: 6px;
}

.btn-close {
  width: 23px;
  height: 23px;

  img {
    width: 100%;
  }
}

.fade-left {
  &-enter-from,
  &-leave-to {
    opacity: 0;
    right: -330px;
  }

  &-enter-active,
  &-leave-active {
    transition: all ease-in-out 0.4s;
  }

  &-enter-to,
  &-leave-from {
    opacity: 1;
    right: 0;
  }
}
</style>
